// Helpers de manipulação do <head> compartilhados entre o controle global
// de SEO e páginas que precisam de metadados dinâmicos (ex.: matérias do blog).

type MetaAttr = 'name' | 'property';

// Atualiza (ou cria) uma meta tag no <head>.
export const setMeta = (attr: MetaAttr, key: string, content: string): void => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
};

// Atualiza (ou cria) o link canônico no <head>.
export const setCanonicalLink = (href: string): void => {
  let link = document.head.querySelector('link[rel="canonical"]');
  if (!link) {
    link = document.createElement('link');
    link.setAttribute('rel', 'canonical');
    document.head.appendChild(link);
  }
  link.setAttribute('href', href);
};

// Remove o link canônico (usado em páginas noindex).
export const removeCanonicalLink = (): void => {
  document.head.querySelector('link[rel="canonical"]')?.remove();
};

// Cria, atualiza ou remove um bloco JSON-LD identificado por um id.
export const setJsonLd = (id: string, data: object | null): void => {
  const existing = document.getElementById(id);
  if (!data) {
    if (existing) existing.remove();
    return;
  }
  if (existing) {
    existing.textContent = JSON.stringify(data);
    return;
  }
  const script = document.createElement('script');
  script.type = 'application/ld+json';
  script.id = id;
  script.textContent = JSON.stringify(data);
  document.head.appendChild(script);
};